import { ROLES, type Role } from '../constants/roles';

export const PERMISSIONS = {
  VIEW_DASHBOARD_SUMMARY: [ROLES.OWNER, ROLES.ADMIN],
  VIEW_TEAM_MENU: [ROLES.OWNER, ROLES.ADMIN],
  VIEW_CREDIT_MENU: [ROLES.OWNER, ROLES.ADMIN],
  CARD_TRACKING_DETAIL: [ROLES.OWNER, ROLES.ADMIN],
  MANAGE_CARD_ACTIONS: [ROLES.OWNER, ROLES.ADMIN],
  EDIT_CARD_METADATA: [ROLES.OWNER, ROLES.ADMIN],
  MANAGE_CARD_LIMIT: [ROLES.OWNER, ROLES.ADMIN],
  VIEW_CARD_TABS: {
    [ROLES.BASIC]: ['asigned'],
    [ROLES.ADMIN]: ['asigned', 'pending', 'traking'],
    [ROLES.OWNER]: ['asigned', 'pending', 'traking'],
  },
  USE_CARD_STATUS_FILTER: [ROLES.OWNER, ROLES.ADMIN],
} as const;

export const getEffectiveRole = (
  role: string | undefined,
  accessRole: string | undefined
): Role => {
  if (accessRole?.toUpperCase() === 'OWNER') {
    return ROLES.OWNER;
  }
  return (role?.toUpperCase() || ROLES.BASIC) as Role;
};

export const hasPermission = (
  userOrRole: string | { role?: string; accessRole?: string } | undefined,
  feature: keyof typeof PERMISSIONS
): boolean => {
  let role: string | undefined;
  let accessRole: string | undefined;

  if (typeof userOrRole === 'object' && userOrRole !== null) {
    role = userOrRole.role;
    accessRole = userOrRole.accessRole;
  } else {
    role = userOrRole;
  }

  const effectiveRole = getEffectiveRole(role, accessRole);
  const allowedRoles = PERMISSIONS[feature];
  if (Array.isArray(allowedRoles)) {
    return allowedRoles.includes(effectiveRole);
  }
  return false;
};

export const isBasic = (userOrRole: string | { role?: string; accessRole?: string } | undefined): boolean => {
  const role = typeof userOrRole === 'object' && userOrRole !== null ? userOrRole.role : userOrRole;
  const accessRole = typeof userOrRole === 'object' && userOrRole !== null ? userOrRole.accessRole : undefined;
  return getEffectiveRole(role, accessRole) === ROLES.BASIC;
};

export const isAdmin = (userOrRole: string | { role?: string; accessRole?: string } | undefined): boolean => {
  const role = typeof userOrRole === 'object' && userOrRole !== null ? userOrRole.role : userOrRole;
  const accessRole = typeof userOrRole === 'object' && userOrRole !== null ? userOrRole.accessRole : undefined;
  return getEffectiveRole(role, accessRole) === ROLES.ADMIN;
};

export const isOwner = (userOrRole: string | { role?: string; accessRole?: string } | undefined): boolean => {
  const role = typeof userOrRole === 'object' && userOrRole !== null ? userOrRole.role : userOrRole;
  const accessRole = typeof userOrRole === 'object' && userOrRole !== null ? userOrRole.accessRole : undefined;
  return getEffectiveRole(role, accessRole) === ROLES.OWNER;
};
